// extracted by mini-css-extract-plugin
export default {"signupPrompt":"m6ZN1J","link":"ggPGGe"};